export const COURSE_CERTIFICATE_QUEUE = 'course-certificate-generate';
export const COURSE_CERTIFICATE_SIGNED_URL_TTL_SEC = 3600;

export const CourseCertificateStatus = {
  PENDING: 'pending',
  GENERATING: 'generating',
  READY: 'ready',
  FAILED: 'failed',
} as const;

export type CourseCertificateStatusValue =
  (typeof CourseCertificateStatus)[keyof typeof CourseCertificateStatus];

export type CourseCertificateGenerateJob = {
  certificateId: string;
};

export function buildCertificatePdfStorageKey(
  courseId: string,
  enrollmentId: string,
  code: string,
): string {
  const safeCode = code.replace(/[^A-Z0-9-]/gi, '').toLowerCase();
  return `courses/${courseId}/certificates/${enrollmentId}/${safeCode}.pdf`;
}

export function formatCertificateIssuedDate(
  date: Date | string,
  locale = 'en-US',
): string {
  const value = date instanceof Date ? date : new Date(date);
  return value.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

export function shouldIssueCourseCertificate(params: {
  certificateEnabled: boolean;
  completedAt?: Date | string | null;
}): boolean {
  return Boolean(params.certificateEnabled && params.completedAt);
}

export function certificateDisplayName(params: {
  displayName?: string | null;
  username?: string | null;
  fallback?: string;
}): string {
  const trimmed = params.displayName?.trim();
  if (trimmed) return trimmed;
  const username = params.username?.trim();
  if (username) return username;
  return params.fallback ?? 'Learner';
}
